import React from 'react';
import PropTypes from 'prop-types';

import { ChirpButton } from 'javascripts/components/chirp_button';

import styles from 'stylesheets/components/search/load_more_button.module';

export function LoadMoreButton(props) {
  return (
    <div className={styles.loadMoreButtonContainer}>
      <ChirpButton label='Load More' onClick={props.loadMore} fullWidth={props.fullWidth} />
    </div>
  );
}

LoadMoreButton.propTypes = {
  loadMore: PropTypes.func.isRequired,
  fullWidth: PropTypes.bool,
};

LoadMoreButton.defaultProps = {
  fullWidth: false,
};
